<template>
    <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card title=" " classHeader="pt-0 mb-0" class="mb-0 h-100 chartOfAccount" fullContent>
                        <gofix-default-table
                            :settings="tableConfig"
                            :table-items="tableItems"
                            @export="exportItems"
                            @load-items="getTableData"
                            @get-column-settings="getColumnSettings"
                            ref="gofixTable">
                            <template slot="gofix_table:before-control-right" slot-scope="data">
                                <div class="mr-2 d-flex align-items-center filterCompany filterMaint">
                                    <span class="mr-1 title">Lifts Inspection Checklist</span>
                                    <gofix-form-dropdown
                                            class="highlightDropdown chartOfAccountDropdown width-120 min-width-0"
                                            label=""
                                            vLabel="text"
                                            :clearable="false"
                                            :filterable="false"
                                            :reduce="option => option.value"
                                            :options="types"
                                            v-model="typeReport"
                                            :placeholder="'Lifts Inspection Checklist'">
                                    </gofix-form-dropdown>
                                </div>
                            </template>
                            <template slot="gofix_table:name" slot-scope="row">
                                <span v-html="row.item.full_section || row.item.section"></span>
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'report-general',
        components: {},
        data() {
            let filter = {
                type: "annual",
                name: { type: "text", value: null, function: "ilike", with: [] },
            };
            return {
                tableItems: [],
                columnSettings: [],
                tableConfig: {
                    name: "mapping-report",
                    controls:{
                        create: false,
                        delete: false,
                        tableImport: false,
                        tableColumnSettings: false,
                        tablePagination: false
                    },
                    filter: filter,
                    fields: [
                        {
                            key: 'key',
                            label: 'Report Reference Key',
                            thStyle: "width: 600px"
                        },
                        {
                            key: 'name',
                            label: 'Report Row',
                            thStyle: "width: 700px",
                            isActive: true,
                            isFilter: true
                        }
                    ],
                    page: 1,
                    limit: -1,
                    total: 0,
                },
                types: [
                    {
                        value: "1Y",
                        text:  "Annually"
                    },
                    {
                        value: "5Y",
                        text:  "5 Years"
                    }
                ],
                typeReport: "1Y"
            }
        },

        computed: {

        },
        async created() {


        },
        watch: {
            typeReport: function(val) {
                this.$refs.gofixTable.reloadTableKeepFilter();
            }
        },
        methods: {
            getColumnSettings(columns) {
                this.columnSettings = this.tableConfig.fields.concat(columns);
            },
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                if(this.$refs.gofixTable)
                    this.$refs.gofixTable.updateColumnSettings(this.columnSettings);

                tableRequest.filter.type = this.typeReport;
                tableRequest.filter.section = null;
                if(tableRequest.filter.name.value) {
                    tableRequest.filter.section = tableRequest.filter.name.value;
                }

                await this.$store.dispatch("MappingReportController/getItems", tableRequest)
                .then(response => {
                    this.tableItems = response.data;
                    this.tableConfig.total = response.length;
                    resolve({});
                })
                .catch(err => {
                    this.$bvToast.toast("Can not load list.", {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'danger',
                        solid: true
                    })
                    reject();
                });
            },
            exportItems(tableRequest) {
                this.$store.dispatch( 'MappingReportController/exportItems', tableRequest)
                .then(response => {
                    let nameFile = "Report Reference Keys - ";
                    if(this.typeReport == "5Y") {
                        nameFile += "5 Years";
                    } else {
                        nameFile += "Annually";
                    }   

                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `${nameFile}.csv`); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                    
                })
            },
        }
    }
</script>
